import request from '../api/request'
import { loadAttributeText } from '../views/inventory/inventoryShared'
import { isConfigEnabled, INVENTORY_BARCODE_ENABLED_PARAM } from '../api/sys/param'

/** 库存条码/序列号：依赖业务设置 inventory-barcode-enabled=1 */
export default {
  data() {
    return {
      inventoryBarcodeEnabled: false,
      barcodeScanCode: ''
    }
  },
  methods: {
    loadInventoryBarcodePolicy() {
      return isConfigEnabled(INVENTORY_BARCODE_ENABLED_PARAM).then(enabled => {
        this.inventoryBarcodeEnabled = enabled
        return enabled
      })
    },
    isSerialMaterial(row) {
      return row && String(row.barcodeManageMode || '') === 'serial'
    },
    serialExpectedQty(row) {
      const q = Number(row && (this.kind === 'counting' ? row.actualQuantity : row.quantity))
      if (!Number.isFinite(q) || q <= 0) return 0
      return Math.floor(q) === q ? q : 0
    },
    onBarcodeScanForLine() {
      const code = (this.barcodeScanCode || '').trim()
      if (!code) return
      request.post('/inventory/barcode/resolve', { scanCode: code }).then(res => {
        const body = res.data || {}
        if (body.resolveType === 'serial') {
          if (this.kind === 'otherIn' || this.kind === 'initialIn' || this.kind === 'ratioIn' || this.kind === 'disassembly') {
            this.$message.warning('入库请使用物料条码加行，再在行内扫描序列号')
            return
          }
          this.applySerialScanToLine(body)
          this.barcodeScanCode = ''
          return
        }
        const row = this.barcodeLine(body, [])
        if (this.kind === 'counting') {
          row.actualQuantity = 1
        }
        this.form.lines.push(row)
        loadAttributeText(row, this)
        this.barcodeScanCode = ''
      }).catch(() => {})
    },
    applySerialScanToLine(res) {
      const sn = (res.serialNo || '').trim()
      if (!sn) return
      let line = (this.form.lines || []).find(item => item.materialId === res.materialId && this.isSerialMaterial(item))
      if (!line) {
        line = this.barcodeLine(res, [])
        line.barcodeManageMode = 'serial'
        if (this.kind === 'counting') {
          line.actualQuantity = 0
        } else {
          line.quantity = 0
        }
        this.form.lines.push(line)
        loadAttributeText(line, this)
      }
      const serialNos = Array.isArray(line.serialNos) ? line.serialNos.slice() : []
      if (serialNos.includes(sn)) {
        this.$message.warning('序列号已在本单中')
        return
      }
      serialNos.push(sn)
      this.$set(line, 'serialNos', serialNos)
      if (this.kind === 'counting') {
        line.actualQuantity = serialNos.length
      } else {
        line.quantity = serialNos.length
      }
    },
    barcodeLine(res, serialNos) {
      const row = {
        materialId: res.materialId,
        materialCode: res.materialCode,
        materialName: res.materialName,
        customerCode: res.customerCode || '',
        specs: res.specs || '',
        barcodeManageMode: res.barcodeManageMode || 'none',
        quantity: 1,
        wareHouseId: '',
        batchNo: '',
        supplierName: '',
        remark: '',
        serialNos: serialNos || []
      }
      if (this.kind === 'transfer') {
        row.fromWareHouseId = ''
        row.toWareHouseId = ''
      }
      if (this.kind === 'counting') {
        row.bookQuantity = 0
        row.actualQuantity = 0
        delete row.quantity
      }
      return row
    }
  }
}
